import { useTypedSelector } from '../../'
import moment from '../../lib/moment-fi'
import { getPunctualityKey } from '../../Selectors'
import { TimetableRow } from '../../types/Input'
import { getTimeLabelText, TimeLabel } from '../DelayLabelRow'

interface Props {
  trainNumber: string
  operatingDate: string
}

const isEstimate = (t: TimetableRow): boolean =>
  !t.actualTime && moment(t.liveEstimateTime).isAfter(moment())

export const TrainEquipmentPunctuality = ({ trainNumber, operatingDate }: Props) => {
  const punctuality = useTypedSelector(
    (state) => state.punctuality.punctualityByTrain[getPunctualityKey(trainNumber, operatingDate)]
  )
  const mostRecentRealRow = punctuality?.timeTableRows.findLast((row) => !isEstimate(row))

  if (!mostRecentRealRow) {
    return null
  }

  return (
    <TimeLabel
      delayMinutes={mostRecentRealRow.differenceInMinutes}
      trainCategory={punctuality.trainCategory}
      notDriving={false}
      estimate={isEstimate(mostRecentRealRow)}
      style={{ display: 'inline-block' }}
    >
      {getTimeLabelText(mostRecentRealRow.differenceInMinutes)}
    </TimeLabel>
  )
}
